/**
 * 带符号显示一个整数：正数与 0 前面补「+」，负数原样（自带「-」）。
 *
 * 商城道具数值允许负数（2026-09-17）后，列表里 `+{{ value }}` 这种硬拼会把 -5 显示成「+-5」，
 * 统一走这里。`-0` 归到「+0」：Object.is(-0, 0) 为 false 但 `-0 >= 0` 为 true，String(-0) 又是 "0"，
 * 所以直接按 `>= 0` 判断即可。
 */
export function signedNumber(n: number): string {
  return n >= 0 ? `+${n}` : String(n)
}
